import 'css-chunksrc/client/pages/projectPage/sideBar/externalLinksList/styles.scss';export default {
  "externalLinksList": "_externalLinksList_1tykv_1",
  "item": "_item_1tykv_7",
  "addLinkIcon": "_addLinkIcon_1tykv_19",
  "linkMenu": "_linkMenu_1tykv_34"
};